import React from 'react';
import { Package, Zap, Sparkles } from 'lucide-react';
export function HowItWorks() {
  const steps = [{
    icon: Package,
    number: 1,
    title: 'Load',
    description: 'Place 1-2 pairs of shoes inside the bag'
  }, {
    icon: Zap,
    number: 2,
    title: 'Zip',
    description: 'Secure the heavy-duty zipper completely'
  }, {
    icon: Sparkles,
    number: 3,
    title: 'Wash',
    description: 'Toss in washer on cold cycle for 45 min'
  }];
  return <div className="my-12 bg-gradient-to-br from-blue-50 to-green-50 rounded-2xl p-8 md:p-12" data-id="element-58">
      <h3 className="text-3xl font-serif font-bold text-center text-gray-900 mb-10" data-id="element-59">
        How It Works
      </h3>

      <div className="grid md:grid-cols-3 gap-8 max-w-4xl mx-auto" data-id="element-60">
        {steps.map((step, index) => {
        const Icon = step.icon;
        return <div key={index} className="relative flex flex-col items-center text-center" data-id="element-61">
              {/* Connector Line (hidden on mobile, shown on desktop between steps) */}
              {index < steps.length - 1 && <div className="hidden md:block absolute top-12 left-[60%] w-[80%] h-0.5 bg-gray-300 z-0" data-id="element-62" />}

              {/* Step Circle */}
              <div className="relative z-10 w-24 h-24 rounded-full bg-[#2d5016] flex items-center justify-center mb-4 shadow-lg" data-id="element-63">
                <Icon className="w-12 h-12 text-white" strokeWidth={2} data-id="element-64" />
              </div>

              {/* Step Number Badge */}
              <div className="absolute top-0 right-[calc(50%-3rem)] w-8 h-8 rounded-full bg-white border-2 border-[#2d5016] flex items-center justify-center font-bold text-[#2d5016] shadow-md z-20" data-id="element-65">
                {step.number}
              </div>

              {/* Step Content */}
              <h4 className="text-xl font-bold text-gray-900 mb-2" data-id="element-66">
                {step.title}
              </h4>
              <p className="text-gray-600" data-id="element-67">{step.description}</p>
            </div>;
      })}
      </div>

      <div className="mt-10 text-center" data-id="element-68">
        <p className="text-lg font-medium text-gray-700" data-id="element-69">
          That's it!{' '}
          <span className="text-[#2d5016] font-bold" data-id="element-70">
            Clean, protected shoes in under an hour.
          </span>
        </p>
      </div>
    </div>;
}